import NoResultFound from "./NoResultFound";
export default NoResultFound;